/**
 * 竖排缩略图画廊的两项行为补充（桌面端，配合 section-main-product.css 的
 * [id^='MainProduct-'] .product--thumbnail_slider 布局）。
 *
 * 按 AGENTS.md 第 8 节，行为改动一律外置，不改 Dawn 的 media-gallery.js：
 * 这里只从外部接住 Dawn 已有的 API（setActiveThumbnail / preventStickyHeader），
 * 原文件保持可升级。
 *
 * 两件事：
 *
 * 1) 缩略图滚动轴。Dawn 的 setActiveThumbnail 用 scrollTo({ left }) 把活动缩略图
 *    滚进视野；缩略图改成竖排后 offsetLeft 恒为 0，那行成了空操作，点击第 9 张
 *    时列表不会跟着滚。这里在原方法之后补一次纵向滚动。
 *
 * 2) 吸顶时抑制页头回弹。页头是 sticky_header_type "on-scroll-up"，向上滚会滑回来，
 *    它比画廊高一层且高 116px，会盖住吸顶主图顶部约 86px。Dawn 自带
 *    'preventHeaderReveal' 事件（sticky-header 收到后改为 hide()），但它是一次性的
 *    （66ms 后自清），所以要在画廊真正吸顶期间每次滚动重新触发。
 *    与 CB2 / Rejuvenation 的行为一致：主图贴边期间页头不出现，直到右侧信息列
 *    回到视口顶部。
 */
(() => {
  const Gallery = customElements.get('media-gallery');
  if (!Gallery) return;

  const desktop = window.matchMedia('(min-width: 750px)');

  // ── 1. 竖排时改用纵向滚动 ──────────────────────────────────────────────
  const original = Gallery.prototype.setActiveThumbnail;
  Gallery.prototype.setActiveThumbnail = function (thumbnail) {
    original.call(this, thumbnail);

    const slider = this.elements?.thumbnails?.slider;
    if (!slider || !thumbnail) return;
    // 没有纵向溢出 = 仍是横排，原方法已经处理完了
    if (slider.scrollHeight <= slider.clientHeight + 1) return;

    // 已经在视野内就别动，否则每次点击都会跳一下
    const item = thumbnail.getBoundingClientRect();
    const box = slider.getBoundingClientRect();
    if (item.top >= box.top - 2 && item.bottom <= box.bottom + 2) return;

    // behavior: 'instant' 是刻意的 —— setActiveMedia 紧接着会排队自己的滚动，
    // 那会打断进行中的平滑动画，导致活动缩略图停在视野外。
    slider.scrollTo({ top: thumbnail.offsetTop, behavior: 'instant' });
  };

  // ── 2. 吸顶期间抑制页头回弹 ────────────────────────────────────────────
  // 用单个文档级监听而不是给每个元素挂：product-info 在切换变体时会重新渲染
  // 整个画廊，挂在元素上的监听会连同旧元素一起失效。
  let cached = null;
  const currentGallery = () => {
    if (cached && cached.isConnected) return cached;
    cached = document.querySelector('media-gallery.product__column-sticky');
    return cached;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (!desktop.matches) return;
      const gallery = currentGallery();
      if (!gallery || typeof gallery.preventStickyHeader !== 'function') return;

      const wrapper = gallery.closest('.product__media-wrapper');
      if (!wrapper) return;

      // 吸顶判定：未吸顶时画廊与其外层的 top 相等；吸顶后外层继续上滚，
      // 而画廊停在吸顶偏移处，于是外层的 top 更小。
      if (wrapper.getBoundingClientRect().top < gallery.getBoundingClientRect().top) {
        gallery.preventStickyHeader();
      }
    },
    // 捕获阶段：要赶在 StickyHeader 自己的 scroll 处理器决定 reveal / hide 之前把标志置上
    { capture: true, passive: true },
  );
})();
